import type React from 'react';

import {
  AsyncKovResourcePicker,
  useLoadSriOptions,
} from '@kathondvla/react-shared-components/src/components';

import type { ApiEvent } from '@generalTypes/eventTypes';
import { trainingApi } from '@store/api/apiConfig';
import moment from 'moment';

const DisplayName = ({ item }) => {
  if (!item) {
    return 'Selecteer een training';
  }
  return `${item.summary} - ${moment(item.startDate).format('DD/MM/YYYY HH:mm')}`;
};

export const EventsDropdown: React.FC<{
  onChange: (value: ApiEvent) => void;
}> = ({ onChange }) => {
  const sriLoadOptionsFn = useLoadSriOptions({
    sriClient: trainingApi,
    href: '/events',
    parameters: {
      type: 'TRAINING',
      publicAndNotFull: true,
      firstOfSeries: true,
      startDateAfter: new Date().toISOString(),
    },
  });

  return (
    <div className="form-group" style={{ marginBottom: '20px' }}>
      <AsyncKovResourcePicker
        loadOptions={sriLoadOptionsFn}
        clearable={false}
        disabled={false}
        onChange={(value) => onChange(value.$$expanded)}
        placeholder="Zoek een training"
        multiple={false}
        menuPlacement="bottom"
        optionValue={(o) => o.key}
        optionTemplate={(o) => <DisplayName item={o?.$$expanded || o} />}
      />
    </div>
  );
};
